const allLocationsConst = [
    {
        address: {
            addressType: 'concrete',
            street1: '8080 N 7th St',
            city: 'New York',
            state: 'NY',
            zipCode: '10003',
            geo: [-73.988122, 40.733521],
            county: 'New York',
        },
        acceptingNewPatients: true,
        acceptsVirtualVisits: false,
        anpCode: 'Y',
        pcpId: '00004341372 008',
        preferred: false,
        premiumTier: false,
        acceptsMedicaid: false,
        inNetworkSpecialties: [0],
        networkEnrollment: [
            {
                network: '52',
                pcpId: '00004341372 008',
                roles: [2],
                planYears: ['2022'],
                medicareBenefitStatusTiers: [],
                accreditationIds: [],
                underlyingNetworkNames: [],
                northCarolinaParticipatingIn: [],
            },
        ],
        phones: [
            {
                number: '+1 347-711-1010',
                phoneType: 'phone',
            },
            {
                number: '+1 845-218-0003',
                phoneType: 'fax',
            },
        ],
        inNetwork: true,
        locationId: '0effb67cbec40c1ba0ca540faba67ec1e9de376d',
        providerDigestId: '33B28EC31F2233980F6F95C45DAE0840',
        tiers: [],
        locationNetworkRestriction: 'inNetwork',
        heartDesignation: 0,
        qualityEfficiency: 'Q94E94',
        providerScheduling: {
            schedulingIds: [],
            hasOnlineScheduling: false,
            hasAvailabilityInNextThirtyDays: false,
        },
        hospitalAffiliations: [],
        areaOfExpertiseIds: [],
        medicalTelehealth: false,
        anpOrReferralType: 'Y',
        isExpressAccess: false,
        customPayerDistinctions: [],
        hcbsAttributes: [],
        telehealth: false,
        suppressTiering: false,
        enableFacilityFeeDisclaimer: false,
        acceptsMedicaidProducts: [],
        bhTelehealth: false,
        medicalTelehealthProducts: [],
        tierType: 'notTiered',
        practiceLimitations: {
            ageLimitation: {
                minAge: 0,
                maxAge: 99,
            },
        },
        groupAffiliations: [],
        northCarolinaAmhTiers: [],
        specialties: [
            {
                id: 0,
                rawSpecialtyCode: '201',
                translatedName: {
                    en: 'Acupuncture',
                    es: 'Acupuntura',
                },
                translatedKeywords: {},
                networks: ['52'],
                anp: {},
            },
        ],
    },
    {
        address: {
            addressType: 'concrete',
            street1: '8080 N 7th St',
            city: 'New York',
            state: 'NY',
            zipCode: '10003',
            geo: [-73.988122, 40.733521],
            county: 'New York',
        },
        acceptingNewPatients: true,
        acceptsVirtualVisits: false,
        anpCode: 'Y',
        pcpId: '00004341372 008',
        preferred: false,
        premiumTier: false,
        acceptsMedicaid: false,
        inNetworkSpecialties: [0],
        networkEnrollment: [
            {
                network: '52',
                pcpId: '00004341372 008',
                roles: [2],
                planYears: ['2022'],
                medicareBenefitStatusTiers: [],
                accreditationIds: [],
                underlyingNetworkNames: [],
                northCarolinaParticipatingIn: [],
            },
        ],
        phones: [
            {
                number: '+1 347-711-1010',
                phoneType: 'phone',
            },
            {
                number: '+1 845-218-0003',
                phoneType: 'fax',
            },
        ],
        inNetwork: true,
        locationId: '1effb67cbec40c1ba0ca540faba67ec1e9de376d',
        providerDigestId: '33B28EC31F2233980F6F95C45DAE0840',
        tiers: [],
        locationNetworkRestriction: 'inNetwork',
        heartDesignation: 0,
        qualityEfficiency: 'Q94E94',
        providerScheduling: {
            schedulingIds: [],
            hasOnlineScheduling: false,
            hasAvailabilityInNextThirtyDays: false,
        },
        hospitalAffiliations: [],
        areaOfExpertiseIds: [],
        medicalTelehealth: false,
        anpOrReferralType: 'Y',
        isExpressAccess: false,
        customPayerDistinctions: [],
        hcbsAttributes: [],
        telehealth: false,
        suppressTiering: false,
        enableFacilityFeeDisclaimer: false,
        acceptsMedicaidProducts: [],
        bhTelehealth: false,
        medicalTelehealthProducts: [],
        tierType: 'notTiered',
        practiceLimitations: {
            ageLimitation: {
                minAge: 0,
                maxAge: 99,
            },
        },
        groupAffiliations: [],
        northCarolinaAmhTiers: [],
        specialties: [
            {
                id: 0,
                rawSpecialtyCode: '201',
                translatedName: {
                    en: 'Acupuncture',
                    es: 'Acupuntura',
                },
                translatedKeywords: {},
                networks: ['52'],
                anp: {},
            },
        ],
    },
    {
        address: {
            addressType: 'concrete',
            street1: '8080 N 7th St',
            city: 'New York',
            state: 'NY',
            zipCode: '10003',
            geo: [-73.988122, 40.733521],
            county: 'New York',
        },
        acceptingNewPatients: true,
        acceptsVirtualVisits: false,
        anpCode: 'Y',
        pcpId: '00004341372 008',
        preferred: false,
        premiumTier: false,
        acceptsMedicaid: false,
        inNetworkSpecialties: [0],
        networkEnrollment: [
            {
                network: '52',
                pcpId: '00004341372 008',
                roles: [2],
                planYears: ['2022'],
                medicareBenefitStatusTiers: [],
                accreditationIds: [],
                underlyingNetworkNames: [],
                northCarolinaParticipatingIn: [],
            },
        ],
        phones: [
            {
                number: '+1 347-711-1010',
                phoneType: 'phone',
            },
            {
                number: '+1 845-218-0003',
                phoneType: 'fax',
            },
        ],
        inNetwork: true,
        locationId: '2effb67cbec40c1ba0ca540faba67ec1e9de376d',
        providerDigestId: '33B28EC31F2233980F6F95C45DAE0840',
        tiers: [],
        locationNetworkRestriction: 'inNetwork',
        heartDesignation: 0,
        qualityEfficiency: 'Q94E94',
        providerScheduling: {
            schedulingIds: [],
            hasOnlineScheduling: false,
            hasAvailabilityInNextThirtyDays: false,
        },
        hospitalAffiliations: [],
        areaOfExpertiseIds: [],
        medicalTelehealth: false,
        anpOrReferralType: 'Y',
        isExpressAccess: false,
        customPayerDistinctions: [],
        hcbsAttributes: [],
        telehealth: false,
        suppressTiering: false,
        enableFacilityFeeDisclaimer: false,
        acceptsMedicaidProducts: [],
        bhTelehealth: false,
        medicalTelehealthProducts: [],
        tierType: 'notTiered',
        practiceLimitations: {
            ageLimitation: {
                minAge: 0,
                maxAge: 99,
            },
        },
        groupAffiliations: [],
        northCarolinaAmhTiers: [],
        specialties: [
            {
                id: 0,
                rawSpecialtyCode: '201',
                translatedName: {
                    en: 'Acupuncture',
                    es: 'Acupuntura',
                },
                translatedKeywords: {},
                networks: ['52'],
                anp: {},
            },
        ],
    },
    {
        address: {
            addressType: 'concrete',
            street1: '8080 N 7th St',
            city: 'New York',
            state: 'NY',
            zipCode: '10003',
            geo: [-73.988122, 40.733521],
            county: 'New York',
        },
        acceptingNewPatients: true,
        acceptsVirtualVisits: false,
        anpCode: 'Y',
        pcpId: '00004341372 008',
        preferred: false,
        premiumTier: false,
        acceptsMedicaid: false,
        inNetworkSpecialties: [0],
        networkEnrollment: [
            {
                network: '52',
                pcpId: '00004341372 008',
                roles: [2],
                planYears: ['2022'],
                medicareBenefitStatusTiers: [],
                accreditationIds: [],
                underlyingNetworkNames: [],
                northCarolinaParticipatingIn: [],
            },
        ],
        phones: [
            {
                number: '+1 347-711-1010',
                phoneType: 'phone',
            },
            {
                number: '+1 845-218-0003',
                phoneType: 'fax',
            },
        ],
        inNetwork: true,
        locationId: '3effb67cbec40c1ba0ca540faba67ec1e9de376d',
        providerDigestId: '33B28EC31F2233980F6F95C45DAE0840',
        tiers: [],
        locationNetworkRestriction: 'inNetwork',
        heartDesignation: 0,
        qualityEfficiency: 'Q94E94',
        providerScheduling: {
            schedulingIds: [],
            hasOnlineScheduling: false,
            hasAvailabilityInNextThirtyDays: false,
        },
        hospitalAffiliations: [],
        areaOfExpertiseIds: [],
        medicalTelehealth: false,
        anpOrReferralType: 'Y',
        isExpressAccess: false,
        customPayerDistinctions: [],
        hcbsAttributes: [],
        telehealth: false,
        suppressTiering: false,
        enableFacilityFeeDisclaimer: false,
        acceptsMedicaidProducts: [],
        bhTelehealth: false,
        medicalTelehealthProducts: [],
        tierType: 'notTiered',
        practiceLimitations: {
            ageLimitation: {
                minAge: 0,
                maxAge: 99,
            },
        },
        groupAffiliations: [],
        northCarolinaAmhTiers: [],
        specialties: [
            {
                id: 0,
                rawSpecialtyCode: '201',
                translatedName: {
                    en: 'Acupuncture',
                    es: 'Acupuntura',
                },
                translatedKeywords: {},
                networks: ['52'],
                anp: {},
            },
        ],
    },
];

export default allLocationsConst;
